"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockLinesToInkText = exports.proseToBlockLines = void 0;
const codex_1 = require("@showrunner/codex");
const proseToBlockLines = (json) => {
    const doc = codex_1.schema.nodeFromJSON(json);
    const lines = [];
    let lineNumber = 0;
    doc.descendants((node, pos, parent) => {
        if ((parent === null || parent === void 0 ? void 0 : parent.type.name) === codex_1.NodeTypeMap.PAGE) {
            lineNumber = lineNumber + 1;
            const text = node.textContent;
            const id = typeof node.attrs.id === 'string' ? node.attrs.id : 'no-id';
            lines.push({
                text,
                id,
                lineNumber,
            });
            // don't descend into children
            return false;
        }
    });
    return lines;
};
exports.proseToBlockLines = proseToBlockLines;
const blockLinesToInkText = (lines) => lines.map((line) => line.text).join('\n');
exports.blockLinesToInkText = blockLinesToInkText;
